// extracted by mini-css-extract-plugin
export default {"eventCaption":"styles_eventCaption__J-q+5","eventWrapper":"styles_eventWrapper__7zyoh","banner":"styles_banner__2WSfM","pic":"styles_pic__mavAw","img":"styles_img__bV5Jx"};